
<div style="position: absolute; float: right; z-index: 100;top: 1em;right: 5em;">
  <mat-icon class="preview-download" matTooltip="{{'buttons.dload' | translate }}" (click)="downloadPdf()">download </mat-icon>
</div>

<pdf-viewer [src]="pdfSrc"  style="width: 100%; height: 90vh; margin-left: 0;"></pdf-viewer>